import {chainWalk, isNonNull} from "./Util";

export const getActiveRoute = (index, defaultRoutes, newRoutes) => {
    const routes = isNonNull(newRoutes) ? newRoutes : defaultRoutes
    if (isNonNull(routes) && index < routes.length) {
        return chainWalk(() => routes[index].route, null)
    }
    return null
}